import React from 'react';

const Facilities = props => (
  <div className="facilities">
    <ul className="facilities-list">
      {props.facilities
        .map((facility, index) => (
          <li className="item" key={index}>
            {' '}
            <span className="title">{facility.name}</span>{' '}
          </li>
        ))
        .splice(0, 6)}
    </ul>
  </div>
);

export default Facilities;



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/with-hotel/components/facilities.js